import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=935a4f4c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935a4f4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('935a4f4c')) {
      api.createRecord('935a4f4c', component.options)
    } else {
      api.reload('935a4f4c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=935a4f4c&scoped=true&", function () {
      api.rerender('935a4f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yR9JkEhu7ocM/JS/comp/SearchFilterTokens.vue"
export default component.exports